<template>
  <span>User logout</span>
</template>

<script>
  export default {
    name: 'LogoutCallback',
    created () {
      this.$router.replace({path: '/'});
    }
  }
</script>
